import axios from "axios";
import SideBar from "./sidebar/ManagerSideBar";
import DashBoardNavbar from "./navbar/DashBoardNavbar";
// export default ProjectDetails;
import * as React from 'react';

import { useNavigate } from 'react-router';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";
import DragnDrop from "../../Utils/DragnDrop";


function UserDetails() {



  return (
    <div className="g-sidenav-show overflow-hidden bg-gray-200">
      {/* side navbar */}
      <SideBar />
      <main className="main-content position-relative h-100 border-radius-lg">
        <DashBoardNavbar />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card my-4">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div className="bg-gradient-info shadow-info border-radius-lg pt-4 pb-3">
                    <h6 className="text-white text-capitalize ps-3">
                      Bulk Upload
                    </h6>
                  </div>
                </div>
                <div className="card-body px-4 pb-2 bg-gray-100   d-flex justify-content-center align-items-center flex-row">
                  <div className="p-0 w-50  d-flex justify-content-center align-items-center ">
                    <DragnDrop />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div
        style={{
          float: "right",
          marginRight: "20px",
          paddingTop: "15px",
        }}
      >

        <div
          className="fixed-bottom d-flex justify-content-end px-3"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            padding: "10px"
          }}
        >


          <span
            className="d-sm-inline d-none"
            style={{ marginLeft: "5px" }}
          ></span>
        </div>
      </div>
    </div >
  );
}

export default UserDetails;